import React, { useState } from "react";
import ReactDOM from "react-dom";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";
import { Slider } from "@mui/material";
import { Button } from "react-bootstrap";
import { toastOptions } from "../../../../../config/toast";
import { toast } from "react-toastify";
import { MuniSpinner2 } from "../../../../../components";

const dogImg =
  "https://img.huffingtonpost.com/asset/5ab4d4ac2000007d06eb2c56.jpeg?cache=sih0jwle4e&ops=1910_1000";

const CropTestREC = ({ classes, foto, i, setValue }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [src, setSrc] = useState(foto?.file);
  const [rotation, setRotation] = useState(0);
  const [isLoadingCrop, setIsLoadingCrop] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    // setIsLoadingCrop(true)
    if (!croppedImage) {
      setIsLoadingCrop(true);
    }
    setCroppedAreaPixels(croppedAreaPixels);
    const croppedImageG = await getCroppedImg(src, croppedAreaPixels, rotation);
    if (croppedImageG) {
      const b64string = croppedImageG.replaceAll("data:image/webp;base64,", "");
      const byteC = atob(b64string);
      const byteN = Array.from(byteC, (char) => char.charCodeAt(0));
      const byteA = new Uint8Array(byteN);
      const originalB = new Blob([byteA], { type: "image/png" });

      const filePatente = new File([originalB], "cropped-image.png", { type: "image/png" });
      setValue(`foto_patente`, filePatente);

      // const a = src.replaceAll("data:image/webp;base64,", "");
      // const byteCharacters = atob(a);
      // const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
      // const byteArray = new Uint8Array(byteNumbers);
      // const originalBlob = new Blob([byteArray], { type: "image/png" });

      // const fileOriginal = new File([originalBlob], "img.png", { type: "image/png" });
      // console.log(fileOriginal)
      // setValue("foto_infraccion1", fileOriginal);

      setCroppedImage(croppedImageG);
      if (croppedImage) {
        setIsLoadingCrop(false);
      }
    }
  };

  return (
    <div className="d-flex flex-column flex-md-row gap-4">
      <div className="d-flex flex-column w-100 w-md-50">
        <div
          style={{
            position: "relative",
            width: "100%",
            // height: "200px",
            background: "#333",
            aspectRatio: "3/4"
          }}
        >
          <Cropper
            style={{ zIndex: "999999", height: "100%" }}
            image={src}
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={4 / 4}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
            maxZoom={5}
          />
        </div>
        <div
          style={{
            // padding: "16px 0",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
          }}
        >
          <div className="d-flex align-items-center justify-content-center gap-4">
            <label className="">Zoom</label>
            <Slider
              value={zoom}
              sx={{
                color: "var(--primary)",
                "& .MuiSlider-thumb": {
                  backgroundColor: "var(--primary)",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "var(--primary)",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "var(--primary)",
                },
              }}
              min={1}
              max={5}
              step={0.1}
              aria-labelledby="Zoom"
              style={{ padding: "22px 0px" }}
              onChange={(e, zoom) => setZoom(zoom)}
            />
          </div>
          <div className="d-flex gap-4 ">
            <label className="mb-0">Rotacion</label>
            <Slider
              value={rotation}
              sx={{
                color: "var(--primary)",
                "& .MuiSlider-thumb": {
                  backgroundColor: "var(--primary)",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "var(--primary)",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "var(--primary)",
                },
              }}
              min={0}
              max={360}
              step={1}
              aria-labelledby="Rotacion"
              onChange={(e, rotation) => setRotation(rotation)}
            />
          </div>
        </div>
      </div>
      <div className="w-100  d-flex justify-content-center">
        {isLoadingCrop ? (
          <MuniSpinner2 />
        ) : croppedImage ? (
          <div className="d-flex flex-column w-100">
            <label>Recorte final: </label>
            <img src={croppedImage} style={{ width: "100%", aspectRatio: "4/4" }} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CropTestREC;
